import styled from 'styled-components';

export const AccountTrendingWrapper = styled.div`
 display: flex;
 width: 100%;
 align-items: center;
 justify-content: center;
 flex-direction: column;
`;
